// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__thS66","actions":"GroupTable_actions__12z6z","deleteModalFooter":"GroupTable_deleteModalFooter__2icbL"};